import { Col, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { LoginAsAgencyAdminApi } from "../../services/agencyService";

function LoginAsAgencyModal({
  agencyId,
  admins = [],
  isModalOpen,
  setModalOpen,
}) {
  const [selectedAdminId, setSelectedAdminId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      setSelectedAdminId(admins?.[0]?.id ? String(admins[0].id) : "");
    }
  }, [isModalOpen, admins]);

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedAdminId("");
  };

  const handleLogin = () => {
    if (!selectedAdminId) {
      toast.error("Please select an admin to login.");
      return;
    }
    setLoading(true);
    LoginAsAgencyAdminApi(agencyId, selectedAdminId)
      .then((response) => {
        setLoading(false);
        setModalOpen(false);
        window.open(
          `${process.env.REACT_APP_AGENCY_WEB_URL}/?t=${response?.id_token}`,
          "_blank"
        );
      })
      .catch((error) => {
        setLoading(false);
        if (error?.status === 500) {
          toast.error(
            "Unauthorized or server issue. Please refresh or try later. "
          );
        } else {
          toast.error(
            error?.error_description
              ? error?.error_description
              : error?.details
                ? error?.details
                : error?.message
          );
        }
      });
  };

  return (
    <Modal
      title="Login as Agency"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={false}
      destroyOnClose
    >
      <div className="mt-1">
        <Row>
          <Col span={24}>
            <Form.Group className="mb-3">
              <Form.Label className="fs-14 fw-500">Select Admin</Form.Label>
              <Form.Select
                className="form-control shadow-none"
                value={selectedAdminId}
                onChange={(e) => setSelectedAdminId(e.target.value)}
                disabled={!admins?.length}
              >
                {!admins?.length ? (
                  <option value="">No admins available</option>
                ) : (
                  admins.map((admin) => (
                    <option key={admin?.id} value={admin?.id}>
                      {`${admin?.firstName ?? ""} ${admin?.lastName ?? ""}`.trim() ||
                        admin?.email ||
                        `Admin #${admin?.id}`}
                      {admin?.email ? ` (${admin.email})` : ""}
                    </option>
                  ))
                )}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Button
              className="btn btn-primary"
              onClick={handleLogin}
              disabled={loading || !admins?.length}
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
            <Button
              className="btn btn-secondary ms-2"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
}

export default LoginAsAgencyModal;
